import "./styles.css";

export default function PulseLoadingMarker() {
  return (
    <div className="pulse-loading-wrapper">
      <div className="pulse-loader"></div>
    </div>
  );
}
